import GradePage from "@/pages/GradePage";
export default function GradeAlgebra1() {
  return <GradePage grade="9" />;
}
